// Common replacements to catch intentional misspellings
const leetReplacements = {
  'a': ['a', '@', '4', 'α', 'д', 'а'],
  'i': ['i', '1', '!', '|', 'І', 'і'],
  'o': ['o', '0', 'О', 'о'],
  'u': ['u', 'υ', 'μ'],
  'e': ['e', '3', 'є'],
  's': ['s', '$', '5', 'ѕ'],
};

// You can expand this list as needed
const badWords = [
  'badword1',
  'badword2',
  // ... add more words
];

// Normalize text for checking
const normalizeText = (text) => {
  let normalized = text.toLowerCase();
  
  // Replace leet speak and similar characters
  Object.entries(leetReplacements).forEach(([char, replacements]) => {
    replacements.forEach(replacement => {
      normalized = normalized.replace(new RegExp(replacement, 'g'), char);
    });
  });
  
  return normalized;
};

// Main filter function
export const filterProfanity = (text) => {
  if (!text) return text;
  
  let filteredText = text;
  const normalizedText = normalizeText(text);
  
  badWords.forEach(word => {
    // Create regex that matches the word with optional special characters in between
    const regex = new RegExp(word.split('').join('\\s*'), 'gi');
    
    if (regex.test(normalizedText)) {
      // Replace with asterisks matching the word length
      filteredText = filteredText.replace(regex, '*'.repeat(word.length));
    }
  });
  
  return filteredText;
};

// Check if text contains profanity
export const containsProfanity = (text) => {
  if (!text) return false;
  
  const normalizedText = normalizeText(text);
  return badWords.some(word => {
    const regex = new RegExp(word.split('').join('\\s*'), 'gi');
    return regex.test(normalizedText);
  });
}; 